import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';
import { UNPAID_REQUEST, UNPAID_SUCCESS, UNPAID_FAILURE, COMMON_FAILURE } from '../../actions';

import { unpaidService } from '../../services';

export type unpaidActionType = {
  type: typeof UNPAID_REQUEST;
  memberID: string;
  history: string[];
};

function* getUnpaid(action: unpaidActionType): Generator<unknown> {
  try {
    const res = yield call(unpaidService(action.memberID).getUnpaid);
    yield put({
      type: UNPAID_SUCCESS,
      res,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: UNPAID_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchGetUnpaid() {
  yield takeLatest(UNPAID_REQUEST, getUnpaid);
}
export default function* unPaidSaga(): Generator<unknown> {
  yield all([fork(watchGetUnpaid)]);
}
